(function () {
  function setOpen(wrap, open) {
    wrap.classList.toggle('is-open', open);
    const btn = wrap.querySelector('.sc-account-help-btn');
    const pop = wrap.querySelector('.sc-account-help-popover');
    if (btn) btn.setAttribute('aria-expanded', String(open));
    // Fail-safe: keep it hidden unless open, even if CSS is missing
    if (pop) pop.style.display = open ? 'block' : 'none';
  }

  function closeAll(exceptWrap) {
    document.querySelectorAll('.sc-account-help-wrap.is-open').forEach((wrap) => {
      if (exceptWrap && wrap === exceptWrap) return;
      setOpen(wrap, false);
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.sc-account-help-btn');
    const wrap = e.target.closest('.sc-account-help-wrap');

    if (btn && wrap) {
      e.preventDefault();
      const isOpen = wrap.classList.contains('is-open');
      closeAll(wrap);
      setOpen(wrap, !isOpen);
      return;
    }

    // Click outside closes
    if (!wrap) closeAll();
  });

  // Hover support (desktop)
  document.addEventListener('mouseover', (e) => {
    const wrap = e.target.closest('.sc-account-help-wrap');
    const btn = e.target.closest('.sc-account-help-btn');
    if (btn && wrap) {
      closeAll(wrap);
      setOpen(wrap, true);
    }
  });

  document.addEventListener('mouseout', (e) => {
    const wrap = e.target.closest('.sc-account-help-wrap');
    const btn = e.target.closest('.sc-account-help-btn');
    if (btn && wrap) setOpen(wrap, false);
  });

  // Escape closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();
